import ContactPageSections from "features/ContactPage";
import React from "react";

const ContactPage = () => {
  return <ContactPageSections />;
};

export default ContactPage;
